import { render, staticRenderFns } from "./BFlowRemoteServiceSelector.vue?vue&type=template&id=6c9dd7f0"
import script from "./BFlowRemoteServiceSelector.vue?vue&type=script&lang=js"
export * from "./BFlowRemoteServiceSelector.vue?vue&type=script&lang=js"
import style0 from "./BFlowRemoteServiceSelector.vue?vue&type=style&index=0&id=6c9dd7f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports